import { render, staticRenderFns } from "./StandardResourceService.vue?vue&type=template&id=373a2df9&scoped=true"
import script from "./StandardResourceService.vue?vue&type=script&lang=js"
export * from "./StandardResourceService.vue?vue&type=script&lang=js"
import style0 from "./StandardResourceService.vue?vue&type=style&index=0&id=373a2df9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373a2df9",
  null
  
)

export default component.exports